import { Action } from 'redux';
import { Llamado, LlamadoListado } from '../../../models/Entities/Turnero';
import { TurneroLlamadosState, TurneroLlamadosUnloadState } from '../../states/Turnero-Llamados.State';

export default function TurneroLlamadosReducer(
    state: TurneroLlamadosState | undefined,
    action: Action
): TurneroLlamadosState {
    const currentState = state ?? TurneroLlamadosUnloadState;
    const a: any = action;

    switch (a.type) {
        case 'TURNERO-LLAMADOS_CREAR_REQUEST':
            return {
                ...currentState,
                isCreating: true,
                successCreating: false,
                failOnCreating: false,
                error: undefined
            } as TurneroLlamadosState;
        case 'TURNERO-LLAMADOS_CREAR_SUCCESS':
            return {
                ...currentState,
                isCreating: false,
                successCreating: true,
                failOnCreating: false,
                error: undefined,
                list: [...(currentState.list || []), a.payload]
            } as TurneroLlamadosState;
        case 'TURNERO-LLAMADOS_CREAR_FAILURE':
            return {
                ...currentState,
                isCreating: false,
                successCreating: false,
                failOnCreating: true,
                error: a.error
            } as TurneroLlamadosState;

        case 'TURNERO-LLAMADOS_GET_ULTIMOS_REQUEST':
            return {
                ...currentState,
                isLoadingUltimos: true,
                successLoadingUltimos: false,
                failOnLoadingUltimos: false,
                error: undefined
            } as TurneroLlamadosState;
        case 'TURNERO-LLAMADOS_GET_ULTIMOS_SUCCESS':
            return {
                ...currentState,
                isLoadingUltimos: false,
                successLoadingUltimos: true,
                failOnLoadingUltimos: false,
                error: undefined,
                ultimos: a.payload || []
            } as TurneroLlamadosState;
        case 'TURNERO-LLAMADOS_GET_ULTIMOS_FAILURE':
            return {
                ...currentState,
                isLoadingUltimos: false,
                successLoadingUltimos: false,
                failOnLoadingUltimos: true,
                error: a.error
            } as TurneroLlamadosState;

        case 'TURNERO-LLAMADOS_PURGE_OLD_REQUEST':
            return {
                ...currentState,
                isPurgingOld: true,
                successPurgingOld: false,
                failOnPurgingOld: false,
                error: undefined
            } as TurneroLlamadosState;
        case 'TURNERO-LLAMADOS_PURGE_OLD_SUCCESS':
            return {
                ...currentState,
                isPurgingOld: false,
                successPurgingOld: true,
                failOnPurgingOld: false,
                error: undefined,
                purgedCount: a.payload
            } as TurneroLlamadosState;
        case 'TURNERO-LLAMADOS_PURGE_OLD_FAILURE':
            return {
                ...currentState,
                isPurgingOld: false,
                successPurgingOld: false,
                failOnPurgingOld: true,
                error: a.error
            } as TurneroLlamadosState;

        default:
            return currentState as TurneroLlamadosState;
    }
}
